var map = {
	"./entrevard.jpg": 437,
	"./hus.jpg": 336,
	"./integritet.jpg": 361,
	"./phonesec.png": 65,
	"./pvakt.png": 114,
	"./secur.webp": 400,
	"./security.jpg": 168,
	"./sthlm.avif": 26,
	"./storningsjour.jpg": 83,
	"./trygghetsvardar.jpg": 255,
	"./vaktare.jpg": 440,
	"./wallpaper.jpg": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;